import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React__default from 'react';
import FieldBase from '../FieldBase/index.js';
import classNames from 'classnames';
var TextareaField = function TextareaField(_ref) {
  var _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
    name = _ref.name,
    value = _ref.value,
    required = _ref.required,
    errorMessage = _ref.errorMessage,
    label = _ref.label,
    optional = _ref.optional,
    invalid = _ref.invalid,
    disabled = _ref.disabled,
    autoComplete = _ref.autoComplete,
    onChange = _ref.onChange,
    customClass = _ref.customClass,
    tooltipConfig = _ref.tooltipConfig,
    rows = _ref.rows,
    cols = _ref.cols,
    resize = _ref.resize,
    spellcheck = _ref.spellcheck,
    minLength = _ref.minLength,
    maxLength = _ref.maxLength,
    inputRef = _ref.inputRef;
  function onChangeHandler(e) {
    var _a;
    if (!!onChange) onChange((_a = e == null ? void 0 : e.target) == null ? void 0 : _a.value);
  }
  var baseClassName = classNames("iq-textarea-field", _defineProperty({
    "iq-textarea-field--invalid": !!invalid,
    "iq-textarea-field--disabled": !!disabled
  }, "iq-textarea-field--".concat(customClass), !!customClass));
  var textareaClassName = classNames("iq-textarea-field__input", {
    "iq-textarea-field__input--no-resize": !resize
  });
  return /* @__PURE__ */React__default.createElement("div", {
    className: baseClassName
  }, /* @__PURE__ */React__default.createElement(FieldBase, {
    required: required,
    errorMessage: errorMessage,
    name: name,
    label: label,
    optional: optional,
    invalid: invalid,
    tooltipConfig: tooltipConfig
  }, /* @__PURE__ */React__default.createElement("textarea", {
    placeholder: placeholder,
    className: textareaClassName,
    onChange: onChangeHandler,
    autoComplete: autoComplete,
    spellCheck: spellcheck,
    value: value,
    rows: rows != null ? rows : 3,
    cols: cols != null ? cols : 50,
    disabled: disabled,
    minLength: minLength,
    maxLength: maxLength,
    ref: inputRef
  })));
};
export { TextareaField as default };